import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=authed
  const [loading, setLoading] = useState(true);
  const [workspace, setWorkspace] = useState(null);
  const loadWorkspace = useCallback(async () => {
    try { const { data } = await api.get("/workspace/me"); setWorkspace(data); } catch { setWorkspace(null); }
  }, []);
  useEffect(() => { if (user) loadWorkspace(); else setWorkspace(null); }, [user, loadWorkspace]);
  const can = (cap) => !!workspace?.caps?.includes(cap);
  const switchCompany = async (companyId) => {
    await api.post("/workspace/switch", { company_id: companyId });
    window.location.assign("/app");
  };

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, logout, checkAuth, workspace, can, switchCompany, loadWorkspace }}>
      {children}
    </AuthContext.Provider>
  );
}
